<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">Regole di consegna dei partner</a>
      </label>
    </div>

    <div class="item nowrap">
      <span class="btn-container top-button-container">

        <button class="btn btn-white vertical full-width-btn align-items-center" routerLink="nuovo">
          Aggiungi<i class="ml-10 fas fa-plus"></i>
        </button>

      </span>
    </div>

    <hr class="gold-hr">

    <section class="main-content wrapper scroll-delivery">
      <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
      <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
        <form class="table-row-container row first-row filter" [formGroup]="partnerDeliveryRulesFilterForm" *ngIf="partnerDeliveryRulesFilterForm" (ngSubmit)="filter()">

            <div class="item data-col-5">
                <h4 class="title" (click)="navigateOrder('PartnerDeliveryRules.id')">
                  <i class="sort-icon fas " [ngClass]="orderIcon('PartnerDeliveryRules.id')"></i>
                  ID
                </h4>
                <span class="data">
                  <input type="number" formControlName="PartnerDeliveryRules.id" min="1000" max="10000" >
                </span>
            </div>

            <div class="item center data-col-20">
              <h4 class="title">DAILY NUMBER RULE</h4>
              <span class="data">
                <select formControlName="PartnerDeliveryRules.perDayDeliveryRule" style="width: 120px;">
                  <option value="">Tutti</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </span>
            </div>

            <div class="item center data-col-20">
              <h4 class="title">TOTAL NUMBER RULE</h4>
              <span class="data">
                <select formControlName="PartnerDeliveryRules.totalDeliveryRule" style="width: 120px;">
                  <option value="">Tutti</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('PartnerDeliveryRules.validFrom')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('PartnerDeliveryRules.validFrom')"></i>
                  VALITIDY
                </h4>
                <span class="data">
                  <div class="date">Da: </div>
                  <input class="date" type="date" formControlName="PartnerDeliveryRules.validFrom">
                </span>
                <span class="data">
                  <div class="date">A: </div>
                  <input class="date" type="date" formControlName="PartnerDeliveryRules.validTill">
                </span>
            </div>

            <div class="item data-col-20">
                <h4 class="title" (click)="navigateOrder(['PartnerDeliveryRules.startTimeRange'])">
                  <i class="sort-icon fas" [ngClass]="orderIcon(['PartnerDeliveryRules.endTimeRange'])"></i>
                  TIME RANGE
                </h4>
                <span class="data">
                    <div class="date">Da: </div>
                    <input class="date" type="time" formControlName="PartnerDeliveryRules.startTimeRange">
                </span>
                <span class="data">
                    <div class="date">A: </div>
                    <input class="date" type="time" formControlName="PartnerDeliveryRules.endTimeRange">
                </span>
            </div>

            <div class="item data-col-30">
                <h4 class="title" (click)="navigateOrder('Partner.businessName')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
                    PARTNER
                </h4>
                <span class="data">
                    <input type="text" formControlName="Partner.businessName" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('PartnerDeliveryRules.kmLimit')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('PartnerDeliveryRules.kmLimit')"></i>
                  KM DISTANCE</h4>
                <span class="data">
                  <select formControlName="PartnerDeliveryRules.kmLimit.operator" style="width: 40px;">
                    <option value="equal">=</option>
                    <option value="lessThan"><</option>
                    <option value="moreThan">></option>
                  </select>
                  <input type="number" formControlName="PartnerDeliveryRules.kmLimit" style="width: 100px;">
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('PartnerDeliveryRules.perDayDeliveryLimit')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('PartnerDeliveryRules.perDayDeliveryLimit')"></i>
                  DAILY NUMBER OF CONSEGNA</h4>
                <span class="data">
                  <select formControlName="PartnerDeliveryRules.perDayDeliveryLimit.operator" style="width: 40px;">
                    <option value="equal">=</option>
                    <option value="lessThan"><</option>
                    <option value="moreThan">></option>
                  </select>
                  <input type="number" formControlName="PartnerDeliveryRules.perDayDeliveryLimit" style="width: 100px;">
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('PartnerDeliveryRules.totalDeliveryLimit')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('PartnerDeliveryRules.totalDeliveryLimit')"></i>
                  TOTAL NUMBER OF CONSEGNA</h4>
                <span class="data">
                  <select formControlName="PartnerDeliveryRules.totalDeliveryLimit.operator" style="width: 40px;">
                    <option value="equal">=</option>
                    <option value="lessThan"><</option>
                    <option value="moreThan">></option>
                  </select>
                  <input type="number" formControlName="PartnerDeliveryRules.totalDeliveryLimit" style="width: 100px;">
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('PartnerDeliveryRules.additionalPrice')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('PartnerDeliveryRules.additionalPrice')"></i>
                  PLUS MINUS PREZZO[PARTNER]</h4>
                <span class="data">
                  <select formControlName="PartnerDeliveryRules.additionalPrice.operator" style="width: 40px;">
                    <option value="equal">=</option>
                    <option value="lessThan"><</option>
                    <option value="moreThan">></option>
                  </select>
                  <input type="number" formControlName="PartnerDeliveryRules.additionalPrice" style="width: 100px;">
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('PartnerDeliveryRules.valetAdditionalPrice')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('PartnerDeliveryRules.valetAdditionalPrice')"></i>
                  PLUS MINUS PREZZO[PARTNER]</h4>
                <span class="data">
                  <select formControlName="PartnerDeliveryRules.valetAdditionalPrice.operator" style="width: 40px;">
                    <option value="equal">=</option>
                    <option value="lessThan"><</option>
                    <option value="moreThan">></option>
                  </select>
                  <input type="number" formControlName="PartnerDeliveryRules.valetAdditionalPrice" style="width: 100px;">
                </span>
            </div>

            <div class="item data-col-5">
                <h4 class="title">TIPO SERVIZIO</h4>
                <span class="data">
                  <select formControlName="PartnerDeliveryRules.serviceType">
                    <option value="">Tutti</option>
                    <!-- <option value="sales">Servizi Vendita</option> -->
                    <option value="hourlyrate">Servizi a Ora</option>
                    <!-- <option value="fixedprice">Servizi a Prezzo Fisso</option> -->
                  </select>
                </span>
            </div>

            <div class="item center data-col-20">
                <h4 class="title">DA FATTURARE</h4>
                <span class="data">
                  <select formControlName="PartnerDeliveryRules.billable" style="width: 120px;">
                    <option value="">Tutti</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </span>
            </div>
        
            <div class="item center data-col-20">
                <h4 class="title">DA PAGARE</h4>
                <span class="data">
                  <select formControlName="PartnerDeliveryRules.payable" style="width: 120px;">
                    <option value="">Tutti</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </span>
            </div>

            <div class="item nowrap">
              <h4 class="title hide-on-mobile">AZIONI</h4>
              <span class="data-row-left btn-container">
                <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                  RICERCA <i class="fas fa-search"></i></button>
                  <br/>
                <button class="btn vertical align-items-center" (click)="resetFilter();">
                  RESET <i class="fas fa-times-circle"></i></button>
              </span>
            </div>
        </form>

        <div class="table-row-container row" *ngFor="let partnerDeliveryRule of partnerDeliveryRules">

            <div class="item data-col-5">
              <span class="data-row-left data-id">
                <h4 class="title table-title">ID :</h4>
                  <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">
                    {{partnerDeliveryRule.id}}
                  </a>
                </span>
            </div>

            <div class="item data-col-20">
              <span class="data-row-left">
                  <h4 class="title table-title">DAILY NUMBER RULE :</h4>
                  <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.perDayDeliveryRule ? "Yes" : "No"}}
                  </a>
                </span>
            </div>

            <div class="item data-col-20">
              <span class="data-row-left">
                  <h4 class="title table-title">TOTAL NUMBER RULE :</h4>
                  <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.totalDeliveryRule ? "Yes" : "No"}}
                  </a>
                </span>
            </div>

            <div class="item data-col-10">
                <span class="data-row-left">
                  <h4 class="title table-title dataGesture">VALITIDY :</h4>
                  <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">
                    {{partnerDeliveryRule.validFrom | date:'dd/MM/yyyy'}} - {{partnerDeliveryRule.validTill | date:'dd/MM/yyyy'}}
                  </a>
                </span>
            </div>

            <div class="item data-col-20">
                <span class="data-row-left">
                    <h4 class="title table-title">TIME RANGE :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{formatTimeShow(partnerDeliveryRule.startTimeRange, partnerDeliveryRule.endTimeRange)}}
                    </a>
                </span>
            </div>

            <div class="item data-col-10">
                <span class="data-row-left">
                    <h4 class="title table-title">PARTNER :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.partner.businessName}}
                    </a>
                </span>
            </div>

            <div class="item data-col-10">
                <span class="data-row-left">
                    <h4 class="title table-title">KM DISTANCE :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.kmLimit}} KM
                    </a>
                </span>
            </div>
            
            <div class="item data-col-10">
                <span class="data-row-left">
                    <h4 class="title table-title">DAILY NUMBER OF CONSEGNA :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.perDayDeliveryLimit}}
                    </a>
                </span>
            </div>
            
            <div class="item data-col-10">
                <span class="data-row-left">
                    <h4 class="title table-title">TOTAL NUMBER OF CONSEGNA :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.totalDeliveryLimit}}
                    </a>
                </span>
            </div>

            <div class="item data-col-10">
                <span class="data-row-left">
                    <h4 class="title table-title">PLUS MINUS PREZZO[PARTNER] :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.additionalPrice}}€ 
                    </a>
                </span>
            </div>

            <div class="item data-col-10">
                <span class="data-row-left">
                    <h4 class="title table-title">PLUS MINUS PREZZO[VALET] :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.valetAdditionalPrice}}€ 
                    </a>
                </span>
            </div>

            <div class="item data-col-10">
                <span class="data-row-left">
                    <h4 class="title table-title">SERVICE :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.serviceType.toUpperCase()}}
                    </a>
                </span>
            </div>

            <div class="item data-col-20">
                <span class="data-row-left">
                    <h4 class="title table-title">DA FATTURARE :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.billable ? "Yes" : "No"}}
                    </a>
                </span>
            </div>

            <div class="item data-col-20">
                <span class="data-row-left">
                    <h4 class="title table-title">DA PAGARE :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.payable ? "Yes" : "No"}}
                    </a>
                </span>
            </div>

            <div class="item nowrap">
                <span class="data-row-left btn-container">
                    <button class="btn vertical align-items-center" [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">MODIFICA</button>
                    <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); delete(partnerDeliveryRule.id)">
                        Elimina<i class="ml-10 far fa-trash-alt"></i>
                    </button>
                </span>
            </div>

        </div>
      </div>
    </section>
  </div>
</section>

<!--
<section class="title-bar content-padding first-item ">
  <div class="wrapper nowrap">
    <h2 class="title-heading">Regole di consegna dei partner</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">
        <button class="btn btn-white vertical align-items-center" routerLink="nuovo">
          Aggiungi<i class="ml-10 fas fa-plus"></i>
        </button>
      </span>
    </div>
  </div>
</section>

<section class="main-content wrapper content-padding scroll-delivery">
    <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage"></app-pagination>
    <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
        <form class="table-row-container row first-row filter" [formGroup]="partnerDeliveryRulesFilterForm" *ngIf="partnerDeliveryRulesFilterForm" (ngSubmit)="filter()">

            <div class="item data-col-5">
                <h4 class="title" (click)="navigateOrder('PartnerDeliveryRules.id')">
                  <i class="sort-icon fas " [ngClass]="orderIcon('PartnerDeliveryRules.id')"></i>
                  ID
                </h4>
                <span class="data">
                  <input type="number" formControlName="PartnerDeliveryRules.id" min="1000" max="10000" >
                </span>
            </div>

            <div class="item center data-col-20">
              <h4 class="title">DAILY NUMBER RULE</h4>
              <span class="data">
                <select formControlName="PartnerDeliveryRules.perDayDeliveryRule" style="width: 120px;">
                  <option value="">Tutti</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </span>
            </div>

            <div class="item center data-col-20">
              <h4 class="title">TOTAL NUMBER RULE</h4>
              <span class="data">
                <select formControlName="PartnerDeliveryRules.totalDeliveryRule" style="width: 120px;">
                  <option value="">Tutti</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('PartnerDeliveryRules.validFrom')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('PartnerDeliveryRules.validFrom')"></i>
                  VALITIDY
                </h4>
                <span class="data">
                  <div class="date">Da: </div>
                  <input class="date" type="date" formControlName="PartnerDeliveryRules.validFrom">
                </span>
                <span class="data">
                  <div class="date">A: </div>
                  <input class="date" type="date" formControlName="PartnerDeliveryRules.validTill">
                </span>
            </div>

            <div class="item data-col-20">
                <h4 class="title" (click)="navigateOrder(['PartnerDeliveryRules.startTimeRange'])">
                  <i class="sort-icon fas" [ngClass]="orderIcon(['PartnerDeliveryRules.endTimeRange'])"></i>
                  TIME RANGE
                </h4>
                <span class="data">
                    <div class="date">Da: </div>
                    <input class="date" type="time" formControlName="PartnerDeliveryRules.startTimeRange">
                </span>
                <span class="data">
                    <div class="date">A: </div>
                    <input class="date" type="time" formControlName="PartnerDeliveryRules.endTimeRange">
                </span>
            </div>

            <div class="item data-col-30">
                <h4 class="title" (click)="navigateOrder('Partner.businessName')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
                    PARTNER
                </h4>
                <span class="data">
                    <input type="text" formControlName="Partner.businessName" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('PartnerDeliveryRules.kmLimit')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('PartnerDeliveryRules.kmLimit')"></i>
                  KM DISTANCE</h4>
                <span class="data">
                  <select formControlName="PartnerDeliveryRules.kmLimit.operator" style="width: 40px;">
                    <option value="equal">=</option>
                    <option value="lessThan"><</option>
                    <option value="moreThan">></option>
                  </select>
                  <input type="number" formControlName="PartnerDeliveryRules.kmLimit" style="width: 100px;">
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('PartnerDeliveryRules.perDayDeliveryLimit')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('PartnerDeliveryRules.perDayDeliveryLimit')"></i>
                  DAILY NUMBER OF CONSEGNA</h4>
                <span class="data">
                  <select formControlName="PartnerDeliveryRules.perDayDeliveryLimit.operator" style="width: 40px;">
                    <option value="equal">=</option>
                    <option value="lessThan"><</option>
                    <option value="moreThan">></option>
                  </select>
                  <input type="number" formControlName="PartnerDeliveryRules.perDayDeliveryLimit" style="width: 100px;">
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('PartnerDeliveryRules.totalDeliveryLimit')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('PartnerDeliveryRules.totalDeliveryLimit')"></i>
                  TOTAL NUMBER OF CONSEGNA</h4>
                <span class="data">
                  <select formControlName="PartnerDeliveryRules.totalDeliveryLimit.operator" style="width: 40px;">
                    <option value="equal">=</option>
                    <option value="lessThan"><</option>
                    <option value="moreThan">></option>
                  </select>
                  <input type="number" formControlName="PartnerDeliveryRules.totalDeliveryLimit" style="width: 100px;">
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('PartnerDeliveryRules.additionalPrice')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('PartnerDeliveryRules.additionalPrice')"></i>
                  PLUS MINUS PREZZO[PARTNER]</h4>
                <span class="data">
                  <select formControlName="PartnerDeliveryRules.additionalPrice.operator" style="width: 40px;">
                    <option value="equal">=</option>
                    <option value="lessThan"><</option>
                    <option value="moreThan">></option>
                  </select>
                  <input type="number" formControlName="PartnerDeliveryRules.additionalPrice" style="width: 100px;">
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('PartnerDeliveryRules.valetAdditionalPrice')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('PartnerDeliveryRules.valetAdditionalPrice')"></i>
                  PLUS MINUS PREZZO[PARTNER]</h4>
                <span class="data">
                  <select formControlName="PartnerDeliveryRules.valetAdditionalPrice.operator" style="width: 40px;">
                    <option value="equal">=</option>
                    <option value="lessThan"><</option>
                    <option value="moreThan">></option>
                  </select>
                  <input type="number" formControlName="PartnerDeliveryRules.valetAdditionalPrice" style="width: 100px;">
                </span>
            </div>

            <div class="item data-col-5">
                <h4 class="title">TIPO SERVIZIO</h4>
                <span class="data">
                  <select formControlName="PartnerDeliveryRules.serviceType">
                    <option value="">Tutti</option>
                    <option value="hourlyrate">Servizi a Ora</option>
                  </select>
                </span>
            </div>

            <div class="item center data-col-20">
                <h4 class="title">DA FATTURARE</h4>
                <span class="data">
                  <select formControlName="PartnerDeliveryRules.billable" style="width: 120px;">
                    <option value="">Tutti</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </span>
            </div>
        
            <div class="item center data-col-20">
                <h4 class="title">DA PAGARE</h4>
                <span class="data">
                  <select formControlName="PartnerDeliveryRules.payable" style="width: 120px;">
                    <option value="">Tutti</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </span>
            </div>

            <div class="item nowrap">
              <h4 class="title hide-on-mobile">AZIONI</h4>
              <span class="data-row-left btn-container">
                <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                  RICERCA <i class="fas fa-search"></i></button>
                  <br/>
                <button class="btn vertical align-items-center" (click)="resetFilter();">
                  RESET <i class="fas fa-times-circle"></i></button>
              </span>
            </div>
        </form>

        <div class="table-row-container row" *ngFor="let partnerDeliveryRule of partnerDeliveryRules">

            <div class="item data-col-5">
              <span class="data-row-left data-id">
                <h4 class="title table-title">ID :</h4>
                  <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">
                    {{partnerDeliveryRule.id}}
                  </a>
                </span>
            </div>

            <div class="item data-col-20">
              <span class="data-row-left">
                  <h4 class="title table-title">DAILY NUMBER RULE :</h4>
                  <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.perDayDeliveryRule ? "Yes" : "No"}}
                  </a>
                </span>
            </div>

            <div class="item data-col-20">
              <span class="data-row-left">
                  <h4 class="title table-title">TOTAL NUMBER RULE :</h4>
                  <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.totalDeliveryRule ? "Yes" : "No"}}
                  </a>
                </span>
            </div>

            <div class="item data-col-10">
                <span class="data-row-left">
                  <h4 class="title table-title dataGesture">VALITIDY :</h4>
                  <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">
                    {{partnerDeliveryRule.validFrom | date:'dd/MM/yyyy'}} - {{partnerDeliveryRule.validTill | date:'dd/MM/yyyy'}}
                  </a>
                </span>
            </div>

            <div class="item data-col-20">
                <span class="data-row-left">
                    <h4 class="title table-title">TIME RANGE :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{formatTimeShow(partnerDeliveryRule.startTimeRange, partnerDeliveryRule.endTimeRange)}}
                    </a>
                </span>
            </div>

            <div class="item data-col-10">
                <span class="data-row-left">
                    <h4 class="title table-title">PARTNER :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.partner.businessName}}
                    </a>
                </span>
            </div>

            <div class="item data-col-10">
                <span class="data-row-left">
                    <h4 class="title table-title">KM DISTANCE :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.kmLimit}} KM
                    </a>
                </span>
            </div>
            
            <div class="item data-col-10">
                <span class="data-row-left">
                    <h4 class="title table-title">DAILY NUMBER OF CONSEGNA :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.perDayDeliveryLimit}}
                    </a>
                </span>
            </div>
            
            <div class="item data-col-10">
                <span class="data-row-left">
                    <h4 class="title table-title">TOTAL NUMBER OF CONSEGNA :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.totalDeliveryLimit}}
                    </a>
                </span>
            </div>

            <div class="item data-col-10">
                <span class="data-row-left">
                    <h4 class="title table-title">PLUS MINUS PREZZO[PARTNER] :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.additionalPrice}}€ 
                    </a>
                </span>
            </div>

            <div class="item data-col-10">
                <span class="data-row-left">
                    <h4 class="title table-title">PLUS MINUS PREZZO[VALET] :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.valetAdditionalPrice}}€ 
                    </a>
                </span>
            </div>

            <div class="item data-col-10">
                <span class="data-row-left">
                    <h4 class="title table-title">SERVICE :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.serviceType.toUpperCase()}}
                    </a>
                </span>
            </div>

            <div class="item data-col-20">
                <span class="data-row-left">
                    <h4 class="title table-title">DA FATTURARE :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.billable ? "Yes" : "No"}}
                    </a>
                </span>
            </div>

            <div class="item data-col-20">
                <span class="data-row-left">
                    <h4 class="title table-title">DA PAGARE :</h4>
                    <a [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">{{partnerDeliveryRule.payable ? "Yes" : "No"}}
                    </a>
                </span>
            </div>

            <div class="item nowrap">
                <span class="data-row-left btn-container">
                    <button class="btn vertical align-items-center" [routerLink]="['/partner/delivery/rules/edit', partnerDeliveryRule.id]">MODIFICA</button>
                    <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); delete(partnerDeliveryRule.id)">
                        Elimina<i class="ml-10 far fa-trash-alt"></i>
                    </button>
                </span>
            </div>

        </div>
    </div>
</section>
-->